export default {
    minuteToHour: function (minute) {
        return this.zeroPadding(Math.floor(minute / 60), 2) + ":" + this.zeroPadding(Math.floor(minute % 60), 2)
    },
    zeroPadding: function (input, length) {
        return (input + "").padStart(length, 0);
    }
}
